import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  standalone: false,
  templateUrl: './not-found.html',
  styleUrls: ['./not-found.css'],
})
export class NotFoundComponent {
  constructor(
    private router: Router,
    private auth: AuthService,
    private location: Location
  ) {}

  goHome(): void {  
    if (this.auth.hasValidSession()) {
      void this.router.navigate(['/dashboard']);
    } else {
      void this.router.navigate(['/login']);
    }
  }

  goBack(): void {
    void this.location.back();
  }
}
